import { render, staticRenderFns } from "./AddTriggerTime.vue?vue&type=template&id=b978a144&scoped=true&"
import script from "./AddTriggerTime.vue?vue&type=script&lang=js&"
export * from "./AddTriggerTime.vue?vue&type=script&lang=js&"
import style0 from "./AddTriggerTime.vue?vue&type=style&index=0&id=b978a144&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b978a144",
  null
  
)

export default component.exports